"use strict";

exports.__esModule = true;
exports.default = void 0;

var _uiPreview = _interopRequireDefault(require("./uiPreview"));

var _uiSchema = _interopRequireDefault(require("./damage/uiSchema"));

var _uiSchema2 = _interopRequireDefault(require("./condition/uiSchema"));

var _uiSchema3 = _interopRequireDefault(require("./task/uiSchema"));

var _uiSchema4 = _interopRequireDefault(require("./work/uiSchema"));

var _uiSchema5 = _interopRequireDefault(require("../attachments/uiSchema"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  "ui:field": "pageEditor",
  "ui:preview": _uiPreview.default,
  "ui:fieldset": ["content"],
  "content": {
    "ui:field": "pageContent",
    "ui:fieldset": ["preview", "damage", "condition", "work", "task"],
    "preview": {
      "ui:titleHidden": true,
      "ui:layout": "primusPreviewSection",
      "ui:fieldset": ["media", "objectId", "conditionId"],
      "media": {
        "ui:field": "primusMedia",
        "ui:layout": "primusPreviewMedia",
        "ui:buttons": ["upload"]
      },
      "objectId": {
        "ui:title": "Identifikasjonsnummer"
      },
      "conditionId": {
        "ui:title": "Overordnet tiltaksklasse"
      }
    },
    "damage": _uiSchema.default,
    "condition": _uiSchema2.default,
    "work": _uiSchema4.default,
    "task": _uiSchema3.default
  }
};
exports.default = _default;
module.exports = exports.default;